import { render, staticRenderFns } from "./Buckets.vue?vue&type=template&id=569dbf9c"
import script from "./Buckets.vue?vue&type=script&lang=js"
export * from "./Buckets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports